<template>
  <section class="">
    <a-row>
      <create-product
        v-model="value"
        title="Mahsulotni o'zgartirish"
        @deleteExtraImg="reRender"
      ></create-product>
      <product-info v-model="value"></product-info>
      <text-editor v-model="value" title="Team"></text-editor>
    </a-row>
    <div class="row ml-2 ml-md-5">
      <div class="col-3 col-md-1 mr-4">
        <a-button @click="confirm" size="large" class="bg-danger text-white  ">
          O'chirish
        </a-button>
      </div>
      <div class="col-3">
        <a-button
          size="large"
          @click="editProduct"
          class="bg-warning text-white  mb-5"
        >
          O'zgartirish
        </a-button>
      </div>
    </div>

    <a-row>
      <h4 class="ml-sm-2 ml-md-4 ml-lg-5 font-weight-normal">
        Qo'shimcha rasm qo'shish
      </h4>
      <product-extra-img
        :productId="productId"
        @re-add-img="reAddImg"
      ></product-extra-img>
    </a-row>

    <modal v-if="inValid" title="Xato" @close="closeModal">
      <p class="text-white bg-danger p-3 mt-3">
        Iltimos mahsulot nomlarni, kategoriya, narx va rasmni kiriting
      </p>
    </modal>
  </section>
</template>

<script>
import CreateProduct from '../../components/Products/CreateProduct.vue';
import ProductInfo from '../../components/Products/ProductInfo.vue';
import TextEditor from '../../components/Products/TextEditor.vue';
import productExtraImg from './productExtraImg.vue';
import { mapActions } from 'vuex';
export default {
  props: ['productId'],
  components: {
    CreateProduct,
    ProductInfo,
    TextEditor,
    productExtraImg,
  },

  data() {
    return {
      inValid: false,
      value: {
        name: '',
        name_en: '',
        name_ru: '',
        name_uz: '',
        price: 0,
        image: {},
        images: [],
        category: 0,
        order: 0,
        info: '',
        info_en: '',
        info_ru: '',
        info_uz: '',
        diametr: '',
        value: '',
      },
    };
  },

  methods: {
    ...mapActions({
      getOneProduct: 'product/getOneProduct',
      patchProduct: 'product/patchProduct',
      deleteOneProduct: 'product/deleteOneProduct',
    }),
    reAddImg() {
      this.reRender();
    },
    reRender() {
      this.getOneProduct(this.productId).then((data) => {
        this.value = data;
      });
    },
    editProduct() {
      let validateObj = {
        name: this.value.name,
        name_en: this.value.name_en,
        name_ru: this.value.name_ru,
        name_uz: this.value.name_uz,
        price: this.value.price,
        image: this.value.image,
      };
      for (let i in validateObj) {
        if (validateObj[i] === '') {
          this.inValid = true;
          return;
        }
      }
      const obj = {
        data: {
          name: this.value.name,
          name_en: this.value.name_en,
          name_ru: this.value.name_ru,
          name_uz: this.value.name_uz,
          price: this.value.price,
          image: this.value.image,
          order: +this.value.order,
          category: this.value.category.id
            ? this.value.category.id
            : this.value.category,
          info: this.value.info,
          info_en: this.value.info_en,
          info_ru: this.value.info_ru,
          info_uz: this.value.info_uz,
          diametr: this.value.diametr,
          value: this.value.value,
        },
        id: this.productId,
      };
      if (!obj.data.image.newData) {
        delete obj.data.image;
      } else {
        obj.data.image = this.value.image.files;
      }
      this.patchProduct(obj)
        .then(() => {
          this.$notification['success']({
            message: "Muvaffaqiyatli o'zgardi",
            description: "Mahsulot muvaffaqiyatli o'zgardi",
          });

          setTimeout(() => {
            this.$router.push({
              path: '/product',
              query: {
                ...this.$router.query,
                page: this.$route.query.page,
              },
            });
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.$notification['error']({
            message: 'Xatolik',
            description:
              'Yangilanish amalga oshmadi birozdan keyin urining ):' +
              error.message,
          });
        });
    },
    closeModal(bool) {
      this.inValid = bool;
    },
    confirm() {
      this.$confirm({
        title: "O'chirish",
        content: "O'chirishga ishonchingiz komilmi",
        okText: 'Ha',
        cancelText: "Yo'q",
        onOk: () => {
          this.deleteOneProduct(this.productId);
          this.$router.push({
            path: '/product',
            query: {
              ...this.$router.query,
              page: this.$route.query.page,
            },
          });
        },
        onCancel() {
          return;
        },
      });
    },
  },

  created() {
    this.getOneProduct(this.productId)
      .then((data) => {
        this.value = data;
      })
      .catch((error) => {
        this.$notification['error']({
          message: 'Xatolik',
          description: "Serverda Xatolik Bo'ldi ):" + error.message,
        });
        setTimeout(() => {
          this.$router.push('/product');
        }, 1000);
      });
  },
};
</script>
